/**
 * Central site configuration used for SEO, canonical URLs, Open Graph,
 * Twitter cards and structured data. Keep production-facing values here so
 * every page stays consistent.
 */

// Allow overriding at build time; fall back to the known production domain.
const siteUrl = (process.env.REACT_APP_SITE_URL || "https://stalleyhouse.com").replace(/\/$/, "");

const siteConfig = {
  siteUrl,
  siteName: "Stalley Beach House",
  // Default <title> used when a page does not provide its own.
  defaultTitle: "Stalley Beach House — Beachfront Costa Rica Vacation Rental",
  // Appended to page-specific titles: "Gallery | Stalley Beach House".
  titleTemplate: "%s | Stalley Beach House",
  defaultDescription:
    "Book Stalley Beach House direct and save 15–20% vs Airbnb. A 6-bedroom beachfront villa near Jacó, Costa Rica with private pool, kayaks, maid & cook. Sleeps 12.",
  // Stable social share image served from /public (1200×630).
  socialImage: `${siteUrl}/og-image.jpg`,
  locale: "en_US",
  themeColor: "#1A73E8",
  // External official listings (used for sameAs in structured data).
  listings: {
    airbnb: "https://www.airbnb.com/rooms/9803481",
    vrbo: "https://www.vrbo.com/4631717",
  },
  contactEmail: "croceanfrontrentals@gmail.com",
};

export default siteConfig;
